export const defaultState = [
  // "austin",
  // "austintexas",
  // "austintx",
  // "austinite",
  // "austinlife"
];

const output = (state = defaultState, action) => {
  switch (action.type) {
    case "FETCH_HASHTAGS_SUCCESS": {
      return [];
    }
    case "SELECT_ONE_ROW": {
      return [...state, action.hashtag];
    }
    case "DESELECT_ONE_ROW": {
      return state.filter(x => x !== action.hashtag);
    }
    case "SELECT_ALL_ROWS": {
      const nextState = state.slice();
      action.hashtags.forEach(x => {
        if (!nextState.includes(x)) {
          nextState.push(x);
        }
      });
      return nextState;
    }
    case "DESELECT_ALL_ROWS": {
      return state.filter(x => !action.hashtags.includes(x));
    }
    default:
      return state;
  }
};

export default output;



// WEBPACK FOOTER //
// ./src/reducers/output.js